import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Returns whether the `}<inlineCode parentName="p">{`rawData`}</inlineCode>{` set is valid, and all the errors that occurred during validation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func primerRawDataManager(_ rawDataManager: PrimerHeadlessUniversalCheckout.RawDataManager, dataIsValid isValid: Bool, errors: [Error]?)
`}</code></pre>
    <h4>{`Parameters`}</h4>
    <Group mdxType="Group">
	<Item title='rawDataManager' subtitle='PrimerHeadlessUniversalCheckout.RawDataManager' mdxType="Item">
		The instance of the raw data manager calling this delegate method
	</Item>
	<Item title='isValid' subtitle='Bool' mdxType="Item">
		Whether the data is valid
	</Item>
	<Item title='errors' subtitle='Array<Error>' mdxType="Item">
		The errors that occured during the validation
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      